import React from "react";

export default function Footer() {
  return (
    <div className="footer">
      made by 
      <a
        className="footer-link"
        target="blank"
        href="https://github.com/alesmazur"
      >
       
        Ales Mazur
      </a>
    </div>
  );
}
